<template>
    <div>
        <!-- Original -->
        <div class="venue-list-container" v-if="!isMaster && env.NAME != 'main' && env.NAME != 'sandbox'">
            <div class="d-flex align-items-center justify-content-between page-title-container">
                <div class="page-title">
                    Venue {{ activeTab }}
                </div>

                <div>
                    <el-tooltip
                        class="box-item"
                        effect="custom-1"
                        content="Logout"
                        placement="left"
                        v-if="!isLoadingLogout"
                    >
                        <el-button class="mt-3 mb-3" type="transparent" @click="logout(venues)">
                            <img src="@/assets/logout.svg" height="30px" class="cursor-pointer" alt="">
                        </el-button>
                    </el-tooltip>

                    <el-button class="mt-3 mb-3" type="transparent" v-if="isLoadingLogout">
                        <i class="el-icon-loading" style="font-size: 27px; font-weight: 900; color: #EA3796;"></i>
                    </el-button>
                </div>
            </div>

            <el-tabs class="venue-tab" v-model="activeTab" :stretch="true" @tab-click="handleActiveTab">
              <el-tab-pane label="Overview" name="overview">
                <div class="venue-list-wrapper">
                  <div class="search-container d-flex aling-items-center justify-content-between">

                      <div class="left">
                          <el-input v-model="searchVenue" class="peiso-input-w-prefix font-16" clearable placeholder="Search a venue">
                              <template #prefix>
                                  <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.7292 21.8491L13.8802 15.0002C13.3594 15.4516 12.7521 15.8031 12.0584 16.0548C11.3646 16.3066 10.6264 16.4325 9.84375 16.4325C7.96594 16.4325 6.37669 15.7814 5.07602 14.4793C3.77534 13.1772 3.125 11.6061 3.125 9.76579C3.125 7.92551 3.77604 6.35433 5.07812 5.05225C6.38021 3.75016 7.95573 3.09912 9.80469 3.09912C11.6536 3.09912 13.2248 3.75016 14.5182 5.05225C15.8116 6.35433 16.4583 7.92681 16.4583 9.76969C16.4583 10.5136 16.3368 11.2328 16.0937 11.9272C15.8507 12.6217 15.4861 13.2727 15 13.8804L21.875 20.7033L20.7292 21.8491ZM9.81771 14.87C11.2283 14.87 12.4273 14.3708 13.4147 13.3726C14.4021 12.3743 14.8958 11.172 14.8958 9.76579C14.8958 8.35954 14.4021 7.15728 13.4147 6.15902C12.4273 5.16075 11.2283 4.66162 9.81771 4.66162C8.39266 4.66162 7.18135 5.16075 6.1838 6.15902C5.18627 7.15728 4.6875 8.35954 4.6875 9.76579C4.6875 11.172 5.18627 12.3743 6.1838 13.3726C7.18135 14.3708 8.39266 14.87 9.81771 14.87Z" fill="currentColor"/>
                                  </svg>

                                  <!-- <img src="@/assets/search.svg" alt=""> -->
                              </template>
                          </el-input>
                      </div>

                      <div class="right d-flex align-items-center">
                          <dayChoice :weekStart="weekStart" @dayChange="dayChangeEvt" @typeChange="typeChangeEvt" :currentChosen="currentChosen" :weekList="weekList" :dashBoardId="dashBoardId" :isMultiSite="isMultiSite" :isPresent="isPresent"/>

                          <div class="slt-wrp">
                              <el-select style="width: 240px" v-model="time" placeholder="No Data" @change="lisKey">
                                  <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item"
                                  :class="{'selected' : item.dashBoardId == selectedWeek.dashBoardId}">
                                  </el-option>
                              </el-select>
                          </div>
                      </div>

                  </div>

                  <!-- <div v-if="isLoading" class="loading">
                      <i class="el-icon-loading"></i>
                      <span>Loading overview data...</span>
                  </div>

                  <div v-if="!isLoading && !venueList.length" class="loading">
                      <span>No venue displayed</span>
                  </div> -->

                  <div class="venue d-flex" v-if="venueList.length">
                      <card-venue v-for="(venue, i) in venueList" :key="`venues-${i}`" :info="venue" :isWeekly="isWeekly" :isPresent="isPresent" @select-venue="chooseVenue" :isLoading="isLoading"></card-venue>

                  </div>
              </div>
              </el-tab-pane>
              <el-tab-pane v-if="venueId == '315'" label="Statistics" name="statistics">
                <div class="venue-list-wrapper" style="height: calc(100vh - 13rem);">
                  <QuicksightDashboard :dashboardUrl="dashboardUrl" />
                </div>


              </el-tab-pane>
            </el-tabs>

        </div>
       <!-- Quick Fix -->
        <div class="select-venue1" v-else>  <!-- v-if="isMaster" -->
            <div class="list">
                <div class="header-container d-flex justify-content-between align-items-center">
                    <h1>Select a Venue to continue</h1>
                    <div class="logout-icon-container cursor-pointer">
                        <div>
                            <el-tooltip
                                class="box-item"
                                effect="custom-1"
                                content="Logout"
                                placement="left"
                                v-if="!isLoadingLogout"
                            >
                                <el-button class="mt-3 mb-3" type="transparent" @click="logout(list)">
                                    <img src="@/assets/logout.svg" height="30px" class="cursor-pointer" alt="">
                                </el-button>
                            </el-tooltip>

                            <el-button class="mt-3 mb-3" type="transparent" v-if="isLoadingLogout">
                                <i class="el-icon-loading" style="font-size: 27px; font-weight: 900; color: #EA3796;"></i>
                            </el-button>
                        </div>
                    </div>
                </div>
                <div class="m-bottom-1rem">
                    <el-input v-model="searchVenue" class="peiso-input-w-prefix font-16" clearable placeholder="Search a venue">
                        <template #prefix>
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.7292 21.8491L13.8802 15.0002C13.3594 15.4516 12.7521 15.8031 12.0584 16.0548C11.3646 16.3066 10.6264 16.4325 9.84375 16.4325C7.96594 16.4325 6.37669 15.7814 5.07602 14.4793C3.77534 13.1772 3.125 11.6061 3.125 9.76579C3.125 7.92551 3.77604 6.35433 5.07812 5.05225C6.38021 3.75016 7.95573 3.09912 9.80469 3.09912C11.6536 3.09912 13.2248 3.75016 14.5182 5.05225C15.8116 6.35433 16.4583 7.92681 16.4583 9.76969C16.4583 10.5136 16.3368 11.2328 16.0937 11.9272C15.8507 12.6217 15.4861 13.2727 15 13.8804L21.875 20.7033L20.7292 21.8491ZM9.81771 14.87C11.2283 14.87 12.4273 14.3708 13.4147 13.3726C14.4021 12.3743 14.8958 11.172 14.8958 9.76579C14.8958 8.35954 14.4021 7.15728 13.4147 6.15902C12.4273 5.16075 11.2283 4.66162 9.81771 4.66162C8.39266 4.66162 7.18135 5.16075 6.1838 6.15902C5.18627 7.15728 4.6875 8.35954 4.6875 9.76579C4.6875 11.172 5.18627 12.3743 6.1838 13.3726C7.18135 14.3708 8.39266 14.87 9.81771 14.87Z" fill="currentColor"/>
                          </svg>
                        </template>
                    </el-input>
                </div>
                <div class="fixed clear">
                    <div class="fixed-name">Venue Name</div>
                    <!-- <div class="fixed-week">Feedback This Week</div> -->
                </div>
                <ul v-if="!loading">
                    <li class="clear" v-for="item in masterVenueList" :key="item.venueId" @click="chooseVenue(item)">
                    <div class="name d-flex gap-10">
                        <span class="font-weight-bold">{{ item.fullVenueName }}</span>
                    </div>
                    <!-- <div class="type-button" :style="{'opacity': 1}"
                    :class="item.class">
                    {{(item.feedbackThisWeek === 0 || item.feedbackThisWeek > 0) ? 'Within Budget' : 'Budget Exceeded'}}
                    </div> -->
                    <!-- <div class="ring" v-if="item.withWarning"></div> -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                    </svg>

                    </li>
                </ul>
                <div class="loading-out-wrp" v-if="loading"><i class="el-icon-loading" style="font-size:20px"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../api/login'
import apiV2 from '../../api/api'
import dayChoice from "../dashboard/component/dayChoice.vue";
import cardVenue from "../card/venue"
import { productFruits } from 'product-fruits';
import QuicksightDashboard from '../quicksight/dashboard.vue';
import { env } from "../../env";


export default {
  name: 'venueselect',
  components: {
    dayChoice: dayChoice,
    cardVenue: cardVenue,
    QuicksightDashboard,
  },
  data () {
    return {
        activeTab: 'overview',
        list: [],
        loading: true,
        env: env,
        showDeputyCycle: false,
        weekStart: 1,
        currentChosen: 0,
        weekList: [],
        dashBoardId: null,
        searchVenue: '',
        options: [],
        time: null,
        selectedType: null,
        pastWeek: null,
        tabController: 0,
        isPresent: false,
        isMultiSite: false,
        // venues: [
        //     {
        //         venueId: 1,
        //         venueName: 'Menard Restaurant',
        //         dailyGuidance: 'Increase revenue by $9,233',
        //         data: {
        //             revenue: {
        //                 targetLabel: 'Target Revenue',
        //                 target: '$9,970.40',
        //                 actualLabel: 'Actual Revenue',
        //                 actual: '$5,665.50',
        //                 varianceLabel: 'Variance',
        //                 variance: '-$11,345.00',
        //             },
        //             roster: {
        //                 targetLabel: 'Roster Target',
        //                 target: '$850.00',
        //                 actualLabel: 'Actual Roster',
        //                 actual: '$1,200.36',
        //                 varianceLabel: 'Variance',
        //                 variance: '+$3,423.00',
        //             }
        //         },
        //         profitIncome: '$83,300.24',
        //     },
        //     {
        //         venueId: 1,
        //         venueName: 'Menard Restaurant 2',
        //         dailyGuidance: 'Increase revenue by $9,233',
        //         data: {
        //             revenue: {
        //                 targetLabel: 'Target Revenue',
        //                 target: '$9,970.40',
        //                 actualLabel: 'Actual Revenue',
        //                 actual: '$5,665.50',
        //                 varianceLabel: 'Variance',
        //                 variance: '-$11,345.00',
        //             },
        //             roster: {
        //                 targetLabel: 'Roster Target',
        //                 target: '$850.00',
        //                 actualLabel: 'Actual Roster',
        //                 actual: '$1,200.36',
        //                 varianceLabel: 'Variance',
        //                 variance: '+$3,423.00',
        //             }
        //         },
        //         profitIncome: '$83,300.24',
        //     },
        //     {
        //         venueId: 1,
        //         venueName: 'Menard Restaurant 3',
        //         dailyGuidance: 'Increase revenue by $9,233',
        //         data: {
        //             revenue: {
        //                 targetLabel: 'Target Revenue',
        //                 target: '$9,970.40',
        //                 actualLabel: 'Actual Revenue',
        //                 actual: '$5,665.50',
        //                 varianceLabel: 'Variance',
        //                 variance: '-$11,345.00',
        //             },
        //             roster: {
        //                 targetLabel: 'Roster Target',
        //                 target: '$850.00',
        //                 actualLabel: 'Actual Roster',
        //                 actual: '$1,200.36',
        //                 varianceLabel: 'Variance',
        //                 variance: '+$3,423.00',
        //             }
        //         },
        //         profitIncome: '$83,300.24',
        //     },

        // ],
        venues: [],
        isWeekly: 0,
        selectedWeek: {},
        isLoading: false,
        isMaster: parseInt(sessionStorage.getItem('isMaster')),
        isLoadingLogout: false,
        venueId: localStorage.getItem('venueId'),
        dashboardUrl: 'https://ap-southeast-2.quicksight.aws.amazon.com/sn/embed/share/accounts/756807855598/dashboards/e6b90c11-56d0-45e3-b2b5-042d1f6659ea?directory_alias=peiso-master'
    }
  },
  watch: {
    selectedWeek: {
        deep: true,
        handler: function(val) {

        }
    }
  },
  computed: {
    venueList() {
        var venue = []
        venue = this.venues.filter((res => {
            if (this.searchVenue.toLowerCase() != '') {
                return res.forSearch.toLowerCase().includes(this.searchVenue.toLowerCase())
            } else {
                return res
            }
        }))

        return venue
    },
    masterVenueList() {
        var venue = []
        this.list.map((n) => {
            n.fullVenueName = n.parentId ? `${n.venueName} (${n.parentId} - ${n.venueId})` : `${n.venueName} (${n.venueId})`
            n.forSearch = n.parentId ? `${n.venueName} ${n.parentId} - ${n.venueId}` : `${n.venueName} ${n.venueId}`
            return n
        })
        venue = this.list.filter((res) => {
            return res.forSearch.toLowerCase().includes(this.searchVenue.toLowerCase())
        })

        return venue
    }
  },
  created () {
      var that = this
      if (!sessionStorage.getItem('token')) {
          this.$router.push('/login')
        return
      }

    this.getOptionalList()
    this.openIntervalOfTenMinutes();
  },
  methods: {
    handleActiveTab() {

    },
    openIntervalOfTenMinutes() {
      setInterval(() => {
        this.getOptionalList();
      }, 600000)
    },
    chooseVenue(item) {
        // Utils.loadings();
        sessionStorage.setItem('subVenueId', item.venueId);
        if (item.parentId) {
            sessionStorage.setItem('parentId', item.parentId);
        } else {
            sessionStorage.removeItem('parentId');
        }
        sessionStorage.setItem('subVenueName', item.venueName);
        sessionStorage.removeItem('isContUsingTrial')


        productFruits.init('zvNdUTfqmAbIOz1V', 'en', { username: item.venueName });

        this.loadDatum()
    },
    async loadDatum() {
        await apiV2.checkDashboardV2()
        await apiV2.checkEosEnable()

        this.$router.push('/dashboard')
        /*api.ordersRevenueDailyToday({
            callback:(load) => {
                Utils.loadings(2);
                if (load.data.code === 0) {
                    this.$router.push('/dashboard')
                }
            }
        })*/
    },

    getVenueOverview(payloads) {
        var isMaster = parseInt(sessionStorage.getItem('isMaster'))

        // Original
        if (!isMaster) {
                var parameters = {
                startTime: payloads.monDateTime,
                endTime: payloads.sunDateTime
                // startTime: 1690725600,
                // endTime: 1691330399
            }

            const venues = localStorage.getItem('venues');
            // if (!venues) {
            //     this.isLoading = true
            // }

            this.isLoading = true;

            if (!this.isWeekly) {
                const weekStart = this.weekStart ? this.weekStart : 7
                var weekName = Utils.getDayName(weekStart)
                parameters.weekName = weekName


                api.venueDailyOverview({
                    params: parameters,
                    callback: (res) => {
                        if (!res.data.code) {
                            this.venues = this.getVenueData(res.data.data)
                            localStorage.setItem('venues', JSON.stringify(this.venues));

                        } else {
                            Utils.alert2('',res.data.message,'error')
                            // this.venues = []
                        }

                        this.isLoading = false
                    }
                })
            } else {

                api.venueWeeklyOverview({
                    params: parameters,
                    callback: (res) => {
                        if (!res.data.code) {
                            this.venues = this.getVenueData(res.data.data)
                            localStorage.setItem('venues', JSON.stringify(this.venues));
                        } else {
                            Utils.alert2('',res.data.message,'error')
                            // this.venues = []
                        }

                        this.isLoading = false
                    }
                })
            }
        }

        this.getSubVenueList()


    },

    getSubVenueList() {
      var that = this
        api.getSubVenueList({
          callback: (res) => {
              that.loading = false
              let {code,data,message}=res.data
              if (code === 0) {
                  data.forEach(item => {
                      if (item.feedbackThisWeek === 0 && !item.withWarning) {
                          item.class = 'green'
                      } else if (item.feedbackThisWeek === 0 && item.withWarning) {
                          item.class = 'white'
                      } else if (item.feedbackThisWeek > 0 && !item.withWarning) {
                          item.class = 'green'
                      } else if (item.feedbackThisWeek > 0 && item.withWarning) {
                          item.class = 'white'
                      } else if (item.feedbackThisWeek < 0) {
                          item.class = 'red'
                      }
                  })

                  that.list = data

                  const venues = localStorage.getItem('venues');

                  if (venues) {

                    this.venues = JSON.parse(venues);
                  } else {
                    this.venues = data.map(res => {
                        return {
                            venueId: res.venueId,
                            venueName: res.venueName,
                            withWarning: res.withWarning,
                            dailyGuidance: '-',
                            data: {
                                revenue: {
                                    targetLabel: 'Revenue Target',
                                    target: '$0.00',
                                    actualLabel: 'Actual Revenue',
                                    actual: '$0.00',
                                    varianceLabel: 'Variance',
                                    variance: '$0.00',
                                },
                                roster: {
                                    targetLabel: 'Roster Target',
                                    target: '$0.00',
                                    actualLabel: 'Actual Roster',
                                    actual: '$0.00',
                                    varianceLabel: 'Variance',
                                    variance: '$0.00',
                                }
                            },
                            profitIncome: '$0.00',
                        }
                    })
                  }

              } else {
                  Utils.alert('',message,'error')
              }
          }
      })
    },

    getVenueData(data) {
        var overviewData = data.map((res) => {
            var targetRevenue = res.targetRevenue >= 0 ? res.targetRevenue : 0
            var actualRevenue = res.actualRevenue >= 0 ? res.actualRevenue : 0
            var targetRoster = res.targetRoster >= 0 ? res.targetRoster : 0
            var actualRoster = res.actualRoster >= 0 ? res.actualRoster : 0
            var revenueDeviation = targetRevenue - actualRevenue
            var rosterDeviation = targetRoster - actualRoster
            var overview = {
                venueId: res.venueId,
                venueName: res.venueName,
                dailyGuidance: res.revenueMessage,
                labourMessage: res.labourMessage,
                withWarning: res.withWarning,
                revenueDeviation: revenueDeviation,
                rosterDeviation: rosterDeviation,
                revenueStatus: revenueDeviation <= 0 ? 1 : 0,
                rosterStatus: rosterDeviation <= 0 ? 0 : 1,
                data: {
                    revenue: {
                        targetLabel: 'Target Revenue',
                        target: Utils.formatTotal(targetRevenue),
                        actualLabel: 'Revenue',
                        actual: Utils.formatTotal(actualRevenue),
                        varianceLabel: 'Variance',
                        variance: Utils.getVariance(actualRevenue, targetRevenue, 'rev'),
                        isWarning: targetRevenue - actualRevenue <= 0 ? 0 : 1
                    },
                    roster: {
                        targetLabel: 'Labour Target',
                        target: Utils.formatTotal(targetRoster),
                        actualLabel: 'Labour',
                        actual: Utils.formatTotal(actualRoster),
                        varianceLabel: 'Variance',
                        variance: Utils.getVariance(actualRoster, targetRoster, 'lab'),
                        isWarning: targetRoster - actualRoster >= 0 ? 0 : 1
                    }
                },
                profitIncome: Utils.formatTotal(res.totalProfit ? res.totalProfit : 0),
            }
            return overview
        })

        return overviewData
    },

    getOptionalList() {
        this.options = Utils.getWeekSelection()
        this.weekList = this.options
        this.dashBoardId = this.options[0].dashBoardId
        this.time = this.options[0].value
        this.isPresent = this.options[0].isPresent
        this.weekStart = new Date().getDay()
        this.selectedWeek = this.options[0]
        this.isMultiSite = true
        this.getVenueOverview(this.selectedWeek)
    },
    dayChangeEvt(e) {
        this.weekStart = e
        this.getVenueOverview(this.selectedWeek)
    },
    typeChangeEvt(e) {
        this.isWeekly = e
        this.isLoading = true;
        this.getVenueOverview(this.selectedWeek)
    },
    lisKey(e) {
        this.time = e.value
        this.dashBoardId = e.dashBoardId
        this.isPresent = e.isPresent
        this.selectedWeek = e
        this.isLoading = true;
        this.getVenueOverview(this.selectedWeek)
    },

    logout(lists){
        this.isLoadingLogout = true
        var venue = lists[0]
        sessionStorage.setItem('subVenueId', venue.venueId)
        sessionStorage.setItem('subVenueName', venue.venueName)
        api.logout({
            callback: this.callback
        })
    },

    callback(res) {
        if(res.data.code == 0) {
            const venues = localStorage.getItem('venues');
            const venueId = localStorage.getItem('venueId');
            sessionStorage.clear()
            localStorage.clear()
            window.location.reload()

            if (venues) {
                localStorage.setItem('venues', venues);
                localStorage.setItem('venueId', venueId);
            }

        } else {
            Utils.alert('', res.data.message, 'error')
            this.isLoadingLogout = false
        }
    }

  }
}
</script>

<style lang="scss" scoped>
@import 'static/scss/fonts/fonts';
@import 'static/scss/colors';
@import 'static/scss/scrollbar';

.select-venue1{
    padding-top: 100px;


    .list{
        width: 1009px;
        padding: 2rem 3rem;

        box-sizing: border-box;
        background: var(--background-color-4);
        box-shadow: 0px 25px 70px 0px rgba(0,0,0,0.1000);
        border-radius: 5px;
        letter-spacing: 0px;
        margin: 0px auto;
        position: relative;
        .header-container {
            margin-bottom: 1rem;
            h1{
                font-size: 30px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: var(--text-color);
                line-height: 42px;
            }
        }
        ul{
            max-height: 500px;
            min-height: 200px;
            overflow-y: auto;
            width: 100%;
            &::-webkit-scrollbar {
                @extend .scrollbar;
            }

            &::-webkit-scrollbar-track {
                @extend .scrollbar-track;
            }

            &::-webkit-scrollbar-thumb {
                @extend .scrollbar-thumb;
            }
            li{
                background: var(--background-color-3);
                border: 1px solid #5F5F5F;
                box-sizing: border-box;
                padding: 15px 20px;
                color: var(--text-color);
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                //background-repeat: no-repeat;
                //background-position: 805px center;
                //background-size: 24px auto;
                //background-image: url('../../assets/chevron-right.svg');
                cursor: pointer;

                svg {
                  position: absolute;
                  right: 20px;
                }
            .name{
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: var(--text-color);
                line-height: 30px;
                // width: 300px;
                float: left;
                // white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                // word-break: break-all;
                margin-right: 14px;
                padding-left: 60px;
                box-sizing: border-box;
            }
            .type-button{
                width: 150px;
                height: 30px;
                border-radius: 20px;
                box-sizing: border-box;
                line-height: 28px;
                font-size: 12px;
                font-family: SFProText-Medium, SFProText;
                font-weight: 500;
                margin-right: 160px;
                float: left;
                text-align: center;
            }
            .white{
                color: var(--text-color);
                border: 1px solid var(--background-color-4);
                background: var(--background-color-4);
            }
            .red{
                color: #F06185;
                border: 1px solid #F06185;
                background: transparent;
            }
            .green{
                color: #3BD578;
                border: 1px solid #3BD578;
                background: transparent;
            }
            .ring{
                width:24px;
                height: 30px;
                float: left;
                background-repeat: no-repeat;
                background-position: left center;
                background-size: contain;
                background-image: url('../../assets/lingdang.png');
            }
            }
        }
        .fixed{
            height: 50px;
            background: var(--background-color-3);
            border: 1px solid #5F5F5F;
            box-sizing: border-box;
            border-bottom: none;
        }
        .fixed-name,.fixed-week{
            float: left;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: var(--text-color);
            line-height: 50px;
            box-sizing: border-box;
        }
        .fixed-name{
            width: 334px;
            padding-left: 80px;
        }
        .loading-out-wrp{
            border: 1px solid #5F5F5F;
            text-align: center;
            line-height: 40px;
            background: var(--background-color-2);
        }
        .el-icon-loading{
            color: var(--text-color);
        }
    }
}

.venue-list-container {
    padding: 55px 70px;

    .search-container {
        margin-bottom: 26px;
    }

    .venue {
        gap: 35px;
        justify-content: left;
        flex-wrap: wrap;

    }

    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        margin-top: 7rem;
        > span {
            @include montserrat-font(24px, normal, 500, $white);
        }

        i {
            color: var(--text-color);
            font-size: 48px;
        }
    }

    .peiso-input-w-prefix {
        width: 415px;
    }

    .search-container {
        .right {
            .dashboard-select {
                margin-bottom: 0px;
            }

            gap: 1rem;

        }
    }

    .page-title-container {
        margin-bottom: 30px;
    }
}

#quicksight-display {

}
</style>



// WEBPACK FOOTER //
// src/components/login/venue.vue